export class H5AudioManager {
    public audio: HTMLAudioElement;
    public title: string = '';
    public epname: string = '';
    public singer: string = '';
    public coverImgUrl: string = '';
    constructor() {
        this.audio = new Audio();// document.createElement('audio');
        // this.audio.autoplay = true;
        this.audio.preload = 'auto';
    }
    public get duration () {
        return this.audio.duration;
    }
    public get currentTime () {
        return this.audio.currentTime;
    }
    public get src () {
        return this.audio.src;
    }
    public set src (value) {
        this.audio.src = value;
        this.audio.load();
    }
    public get state () {
        return this.audio.readyState;
    }
    public get playbackRate () {
        return this.audio.playbackRate;
    }
    public set playbackRate(value) {
        this.audio.playbackRate = value;
    }
    public onCanplay = (callback?: (() => void)) => {
        // this.audio.oncanplaythrough = callback as any;
        this.audio.oncanplay = callback as any;
        // this.audio.onloadedmetadata = callback as any;
    }
    public onTimeUpdate = (callback?: (() => void) | undefined): void => {
        this.audio.ontimeupdate = callback as any;
    }
    public onError = (callback?: (() => void) | undefined): void => {
        this.audio.onerror = callback as any;
    }
    public onPause = (callback?: (() => void) | undefined): void => {
        this.audio.onpause = callback as any;
    }
    public onStop = (): void => {
    }
    public onPlay = (callback?: () => void): void => {
        this.audio.onplay = callback as any;
    }
    public onNext = (): void => {}
    public onPrev = (): void => {}
    public onEnded = (callback?: () => void): void => {
        this.audio.onended = callback as any;
    }
    public onDurationChange = (callback?: (ev: Event) => void): void => {
        this.audio.ondurationchange = callback as any;
    }
    public pause = () => {
        this.audio.pause();
    }
    public play = () => {
        this.audio.play();
    }
    public seek = (s: number) => {
        this.audio.currentTime = s;
    }
}